var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 2.40469C24.5703 2.8125 23.5797 3.08281 22.5469 3.21406C23.6094 2.57969 24.4203 1.58281 24.8016 0.38125C23.8109 0.971875 22.7172 1.38906 21.5516 1.62188C20.6109 0.620313 19.2703 0 17.8078 0C14.9703 0 12.6859 2.30313 12.6859 5.12656C12.6859 5.53281 12.7203 5.92344 12.8047 6.29531C8.54375 6.0875 4.77344 4.04531 2.24062 0.934375C1.79844 1.70156 1.53906 2.57969 1.53906 3.525C1.53906 5.3 2.45312 6.87344 3.81562 7.78437C2.99219 7.76875 2.18438 7.52969 1.5 7.15313C1.5 7.16875 1.5 7.18906 1.5 7.20937C1.5 9.7 3.27656 11.7688 5.60625 12.2453C5.18906 12.3594 4.73438 12.4141 4.2625 12.4141C3.93438 12.4141 3.60312 12.3953 3.29219 12.3266C3.95625 14.3563 5.84063 15.8484 8.08125 15.8969C6.3375 17.2609 4.12344 18.0828 1.72656 18.0828C1.30625 18.0828 0.903125 18.0641 0.5 18.0125C2.77031 19.4766 5.46094 20.3125 8.3625 20.3125C17.7938 20.3125 22.95 12.5 22.95 5.72812C22.95 5.50156 22.9422 5.28281 22.9312 5.06563C23.9484 4.34375 24.8031 3.44219 25.5 2.40469Z",
    fill: "#F5FCFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.780d06d4.svg";
export { ForwardRef as ReactComponent };